import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import moment from 'moment'

const useStyles = makeStyles((theme) => ({
	dialogActions: {
		justifyContent: 'flex-start',
		paddingTop: 24
	}
}))

const RemovedAddOnsDialog = (props) => {
	const classes = useStyles()
	let { removed_addons, isShown, setIsShown, saveVisit } = props

	const width = '460px'
	return (
		<Dialog
			open={isShown}
			className={classes.dialog}
			onClose={() => setIsShown(false)}
			PaperProps={{
				style: {
					minWidth: width,
					maxWidth: width,
					width: width
				}
			}}>
			<DialogTitle
				style={{
					marginBottom: 24
				}}>
				REMOVED ENRICHMENTS
			</DialogTitle>
			<DialogContent>
				<Typography
					variant="body2"
					style={{
						marginBottom: 24
					}}>
					Making these adjustments will remove the following enrichments from the visit due to date or
					time conflicts. After saving your changes, please re-add them to an appropriate date/time as
					needed.
				</Typography>
				{removed_addons.map((a) => {
					return (
						<Typography variant="body2">
							{a.name} - {moment(a.date).format('MMM D')} - {a.time}
						</Typography>
					)
				})}
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<Button variant="contained" onClick={() => saveVisit()} color="secondary">
					SAVE VISIT ANYWAY
				</Button>
				<Button variant="outlined" onClick={() => setIsShown(false)} color="secondary">
					GO BACK
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default RemovedAddOnsDialog
